import type { Breadcrumb } from '@iheartjane/types';
import { clsx } from 'clsx';
import { Fragment } from 'react';

import { BloomLink } from '@jane/bloom/components/bloomLink';

import styles from './breadcrumbs.module.css';

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
  visibleOnViewports?: 'desktop' | 'all';
}

export function Breadcrumbs({
  breadcrumbs,
  className,
  visibleOnViewports = 'all',
}: BreadcrumbsProps) {
  return (
    <div
      className={clsx(
        styles['breadcrumbs'],
        {
          [styles['breadcrumbs--desktop-only']]:
            visibleOnViewports === 'desktop',
        },
        className
      )}
    >
      {breadcrumbs.map(({ title, url }, index) => (
        <Fragment key={title}>
          {url ? (
            <BloomLink to={url} variant="reefer-underline">
              {title}
            </BloomLink>
          ) : (
            <div className={styles['breadcrumbText']}>{title}</div>
          )}
          {index !== breadcrumbs.length - 1 ? <span> /</span> : null}
        </Fragment>
      ))}
    </div>
  );
}
